import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Config } from "../../../../../../Config";
import DetailsModal from "./DetailsModal";
import Anonymous from "../../../../../../Assets/Images/Anonymous.svg";
import DeleteAlert from "./DeleteAlert";
import { formatDate } from "../../../../../../Helper_functions";
import IconSwitch from "../../../ShareElements/Switch/IconSwitch";

const JobItem = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [Candidates, setCandidates] = useState([]);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);

  useEffect(() => {
    let Candidates = [];
    props.Item.candidates.map((Candidate) => {
      if (!Candidate.deleted) {
        Candidates.push(Candidate);
      }
    });
    setCandidates(Candidates);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const displayStatus = (Status) => {
    if (Status === "IN_PROGRESS") {
      return (
        <span className="status-label" style={{ backgroundColor: "#D9B16C" }}>
          {translateText("in_progress")}
        </span>
      );
    } else if (Status === "POPULAR") {
      return (
        <span className="status-label" style={{ backgroundColor: "#A781E3" }}>
          {translateText("popular")}
        </span>
      );
    } else if (Status === "ACCEPTED") {
      return (
        <span className="status-label" style={{ backgroundColor: "#71D9BB" }}>
          {translateText("jpa_status_accepted")}
        </span>
      );
    } else if (Status === "NEW") {
      return (
        <span className="status-label" style={{ backgroundColor: "#6DA2F2" }}>
          {translateText("new")}
        </span>
      );
    } else if (Status === "NOT_STARTED" || Status === null) {
      return (
        <span className="status-label" style={{ backgroundColor: "#DE8C8C" }}>
          {translateText("not_started")}
        </span>
      );
    }
  };
  const toggleBookmark = () => {
    if (
      document
        .getElementById(props.Item.id + "-bookmark")
        .classList.contains("bookmarked") ||
      document
        .getElementById(props.Item.id + "-bookmark")
        .classList.contains("bookmarked-no-animation")
    ) {
      document
        .getElementById(props.Item.id + "-bookmark")
        .classList.remove("bookmarked");
      document
        .getElementById(props.Item.id + "-bookmark")
        .classList.remove("bookmarked-no-animation");
    } else {
      document
        .getElementById(props.Item.id + "-bookmark")
        .classList.add("bookmarked");
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recruitment/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        projectId: props.Item.project.id,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.ToggleRefreshData();
      })
      .catch((Err) => {
        console.log(Err);
        if (
          document
            .getElementById(props.Item.id + "-bookmark")
            .classList.contains("bookmarked")
        ) {
          document
            .getElementById(props.Item.id + "-bookmark")
            .classList.remove("bookmarked");
        } else {
          document
            .getElementById(props.Item.id + "-bookmark")
            .classList.add("bookmarked");
        }
      });
  };
  const shortenDescription = (Desc) => {
    if (Desc !== null) {
      if (Desc.length < 189) {
        return Desc;
      } else {
        return Desc.slice(0, 189) + " ...";
      }
    }
  };
  const displayAvatars = (People) => {
    let FirstThree = [...People].splice(0, 3);
    return (
      <React.Fragment>
        {FirstThree.map((Person) => (
          <React.Fragment>
            {Person.deleted ? null : (
              <React.Fragment>
                {Person.revealIdentity ? (
                  <React.Fragment>
                    {Person.imageThumbnailUrl === null ? (
                      <div
                        className="person"
                        style={{
                          backgroundColor: Person.backgroundColorCode,
                        }}
                      >
                        <p
                          style={{
                            color: Person.textColorCode,
                          }}
                        >
                          {Person.firstName
                            ? Person.firstName.slice(0, 1)
                            : null + Person.lastName
                            ? Person.lastName.slice(0, 1)
                            : null}
                        </p>
                      </div>
                    ) : (
                      <div className="person">
                        <img
                          alt="candidate"
                          className="candidate-avatar"
                          src={Person.imageThumbnailUrl}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ) : (
                  <div className="person anonymous-person">
                    <img alt="" src={Anonymous} />
                  </div>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        ))}
        {People.length <= 3 ? null : (
          <div className="other-people">
            {"+" + parseInt(People.length - 3)}
          </div>
        )}
      </React.Fragment>
    );
  };
  const displaySkills = (SkillsList) => {
    if (SkillsList === undefined) {
      return <div className="skills-wrapper"></div>;
    } else if (SkillsList.length > 0) {
      let ShortSkills = [];
      let AllSkills = [...SkillsList];
      for (let i = 0; i < AllSkills.length; i++) {
        if (AllSkills[i] !== null && AllSkills[i].title.length < 14) {
          ShortSkills.push(AllSkills[i]);
        }
      }
      return (
        <div className="skills-wrapper">
          {ShortSkills.splice(0, 2).map((Skill) => (
            <section key={Skill.id} className="skill-item">
              {Skill.title}
            </section>
          ))}
          <button className="more-skills" onClick={() => setModalIsOpen(true)}>
            <i className="feather-more-vertical"></i>
          </button>
        </div>
      );
    }
  };
  const displayDate = (updatedTime) => {
    return formatDate(new Date(updatedTime).getTime());
  };
  const shortenTitle = () => {
    let Title = props.Item.project.title;
    if (Title.length < 33) {
      return Title;
    } else {
      let Shortened = Title.slice(0, 30) + "...";
      return (
        <React.Fragment>
          {Shortened}
          <p className="popup-title">{Title}</p>
        </React.Fragment>
      );
    }
  };
  const shortenLocation = () => {
    if (props.Item.project.workCity !== null) {
      let Location = props.Item.project.workCity;
      if (Location.length < 33) {
        return Location;
      } else {
        let Shortened = Location.slice(0, 30) + "...";
        return (
          <React.Fragment>
            {Shortened}
            <p className="popup-title">{Location}</p>
          </React.Fragment>
        );
      }
    }
  };
  const requestDetails = () => {
    window.localStorage.setItem("JPAItemId", props.Item.project.id);
    document.getElementById("trigger-details" + props.Item.project.id).click();
  };
  const toggleDeleteJPA = () => {
    setDeleteIsOpen(true);
  };
  const deleteJPA = () => {
    let Req = {
      method: "DELETE",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recruitment/delete",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        projectId: props.Item.project.id,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteIsOpen(false);
        props.ToggleRefreshData();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const togglePublish = () => {
    let Action;
    if (
        document
            .getElementById(props.Item.id + "-icon-switch")
            ?.classList?.contains("icon-switch-wrapper-active")
    ) {
      Action = "PUBLISH";
    } else {
      Action = "UNPUBLISH";
    }

    const Id = props.Item.project.id;
    const ReqURL = window._env_.API_URL + Config.ProjectServiceURL + "/api/project/preset/publish-unpublish";

    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: Id,
        action: Action,
      },
    };
    axios(Req)
        .then((Res) => {
          console.log(Res);
        })
        .catch((Err) => {
          console.log(Err);
        });
  };

  return (
    <div className="job-item">
      {ModalIsOpen ? (
        <DetailsModal
          Job={props.Item}
          LangData={props.LangData}
          Close={() => setModalIsOpen(false)}
        />
      ) : null}
      {DeleteIsOpen ? (
        <DeleteAlert
          Data={props.Item}
          Close={() => setDeleteIsOpen(false)}
          Accept={() => deleteJPA()}
          Cancel={() => setDeleteIsOpen(false)}
          LangData={props.LangData}
        />
      ) : null}
      {displayStatus(props.Item.project.recruitmentStatus)}
      {props.Item.project.createdManually ? (
          <div className="publish-switch">
            <IconSwitch
                IsActive={props.Item.project.published}
                Id={props.Item.id}
                ChangeEvent={() => togglePublish()}
            />
          </div>
      ) : null}
      <button
        className={
          props.Item.bookmarked
            ? "bookmark-btn bookmarked-no-animation"
            : "bookmark-btn"
        }
        id={props.Item.id + "-bookmark"}
        onClick={() => toggleBookmark()}
      ></button>
      {props.Item.project.recruitmentStatus === "ACCEPTED" ? (
        <div className="delete-btn" onClick={() => toggleDeleteJPA()}></div>
      ) : null}
      <div className="item-body">
        <h1 className="item-title">{shortenTitle()}</h1>
        {props.Item.project.globalProjectCode ? (
          <p className="small-info">
            {"(" + props.Item.project.globalProjectCode + ")"}
          </p>
        ) : null}
        <p className="item-location">{shortenLocation()}</p>
        <p className="item-description">
          {shortenDescription(props.Item.project.description)}
        </p>
        <section className="people">
          <div className="avatars-holder">{displayAvatars(Candidates)}</div>
          {Candidates.length > 0 ? (
            <span className="view-candidates" onClick={() => requestDetails()}>
              {translateText("view_candidates")}
              <NavLink
                id={"trigger-details" + props.Item.project.id}
                to="/ProjectDetails/"
              ></NavLink>
            </span>
          ) : (
            <span className="view-candidates disabled-view-btn">
              {translateText("no_candidates_info_text")}
              <NavLink
                id={"trigger-details" + props.Item.project.id}
                to="/ProjectDetails"
              ></NavLink>
            </span>
          )}
        </section>
        <section className="required-skills">
          {displaySkills(props.Item.requiredSkills)}
        </section>
      </div>
      <div className="item-footer">
        <section className="footer-head">
          <i className="feather-calendar"></i>
          <p className="head-label">{translateText("available_since")}</p>
          <p className="head-date">{displayDate(props.Item.createdTime)}</p>
        </section>
        <span className="view-details" onClick={() => requestDetails()}>
          {translateText("view_details")}
        </span>
      </div>
    </div>
  );
};

export default JobItem;
